import React, { useEffect, useState } from 'react';
import { Box, Button, Card, Divider, Drawer, IconButton, styled, Typography } from '@mui/material';
import { Outlet, useNavigate } from 'react-router';
import { Icon } from '@iconify/react';
import { useDispatch, useSelector } from 'react-redux';
import { fCurrency } from '../../utils/formatNumber';
import { analytics, firestore } from '../../contexts/FirebaseContext';
import { removeItemAction, getLockerInfoAction } from '../../redux/slices/dagpacket';
import useAuth from '../../hooks/useAuth';
import { analyticsEvents } from '../../constants/analyticsEvents';

const CuztomLayout = styled('div')(() => ({
  position: 'relative',
  paddingTop: '50px'
}));

const CartButton = styled(Card)(() => ({
  width: '70px',
  height: '70px',
  borderRadius: '50%',
  position: 'absolute',
  top: '10px',
  right: '100px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '30px',
  cursor: 'pointer'
}));

const CartCounter = styled('span')(({ theme }) => ({
  width: '30px',
  height: '30px',
  borderRadius: '50%',
  fontSize: '15px',
  background: theme.palette.grey[300],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

function LockerMainLayout() {
  const [toggleCart, setToggleCart] = useState(false);
  const { checkout } = useSelector((state) => state.dagpacket);
  const { user } = useAuth();
  const dispatch = useDispatch();
  // console.log(user);

  useEffect(() => {
    if (user.id) {
      firestore
        .collection('users')
        .doc(user.id)
        .onSnapshot((doc) => {
          console.log(doc.data());
          dispatch(getLockerInfoAction(doc.data()));
        });
    }
  }, [user, dispatch]);

  return (
    <CuztomLayout>
      {/* <CartButton onClick={() => setToggleCart(true)}>
        <Icon icon="eva:shopping-cart-fill" />
        <CartCounter>{checkout.cart.length}</CartCounter>
      </CartButton>
      <CartProduct toggle={toggleCart} setToggle={setToggleCart} /> */}
      <Outlet />
    </CuztomLayout>
  );
}

export default LockerMainLayout;

const BoxSec = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: '100px 1fr',
  textAlign: 'initial'
  // display: 'flex',
  // gap: '10px',
  // textAlign: 'initial'
}));

function CartProduct({ toggle, setToggle }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { checkout } = useSelector((state) => state.dagpacket);
  const { cart, total } = checkout;

  const removeItem = (id) => {
    dispatch(removeItemAction(id));
  };
  return (
    <Drawer anchor="right" open={toggle} onClose={() => setToggle(false)}>
      <Box width="300px" padding={2}>
        <Box>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h4" component="h3" color="primary" sx={{ fontWeight: 600 }}>
              Cart
            </Typography>
            <IconButton color="error" size="large" onClick={() => setToggle(false)}>
              <Icon icon="eva:close-fill" />
            </IconButton>
          </Box>
          <Divider />
          {cart.length > 0 &&
            cart.map((item) => {
              const { object_id, city_from, city_to, shippingValue, name_from, name_to } = item;
              return (
                <Box key={object_id} marginTop={2}>
                  <Box display="flex" justifyContent="space-between" alignItems="center" gap={1}>
                    <h6 style={{ fontSize: '16px' }}>
                      {city_from} a {city_to}
                    </h6>
                    <p style={{ fontSize: '15px' }}>{fCurrency(shippingValue)}</p>
                  </Box>
                  <Box>
                    <BoxSec>
                      <h5 style={{ fontSize: '14px' }}>Remitente:</h5>
                      <p style={{ fontSize: '14px' }}>{name_from}</p>
                    </BoxSec>
                    <BoxSec>
                      <h5 style={{ fontSize: '14px' }}>Destinatario:</h5>
                      <p style={{ fontSize: '14px' }}>{name_to}</p>
                    </BoxSec>
                  </Box>
                  <Box marginTop={2} textAlign="initial">
                    <IconButton color="error" onClick={() => removeItem(object_id)}>
                      <Icon icon="eva:trash-2-outline" />
                    </IconButton>
                  </Box>
                  <Divider />
                </Box>
              );
            })}
        </Box>
        {cart.length > 0 && (
          <>
            <Box marginTop={1} display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize="25px" variant="subtitle1">
                Total:
              </Typography>
              <Typography fontSize="25px">{fCurrency(total)}</Typography>
            </Box>
            <Button
              fullWidth
              variant="contained"
              color="info"
              sx={{ marginTop: '15px' }}
              onClick={() => {
                navigate('/locker/cotizaciones/cart');
                setToggle(false);
                analytics.logEvent(analyticsEvents.purchase);
              }}
            >
              Pagar
            </Button>
          </>
        )}
        {cart.length === 0 && (
          <Box display="flex" flexDirection="column" gap="30px" alignItems="center" marginTop={4}>
            <img width="40%" src="/static/illustrations/empty_cart.svg" alt="cart" />
            <h6 style={{ fontSize: '15px', textAlign: 'center' }}>El carrito de compras está vacio.</h6>
          </Box>
        )}
      </Box>
    </Drawer>
  );
}
